var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPiechart = function SvgPiechart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 85.333c-234.667 0-426.667 192-426.667 426.667s192 426.667 426.667 426.667 426.667-192 426.667-426.667S746.667 85.333 512 85.333m42.667 88.32c154.027 19.2 276.48 142.08 295.68 295.68h-295.68zM170.667 512c0-173.227 130.987-317.44 298.667-338.347v677.12C301.654 829.44 170.667 685.226 170.667 512m384 338.347v-295.68h295.68c-19.2 154.027-141.653 276.48-295.68 295.68"
  })));
};
export default SvgPiechart;